const unitIncrements = {
  metric: 2.5,
  imperial: 5,
};

/**
 * Round a given weight to gym units if needed.
 */
const roundIncrement = (val, units, roundIncrement) => {
  if (!val && val !== 0) return;

  if (roundIncrement) {
    const increment = unitIncrements[units];
    return Math.round(val / increment) * increment;
  }

  return Math.round(val * 10) / 10;
};

export default roundIncrement;
